import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { listCourseDrafts } from './infra/repository/CourseDraftRepository';
import './course-editor.scss';

export default function CourseDraftList() {
  const [drafts, setDrafts] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    listCourseDrafts().then(data => { if (active) setDrafts(data); })
      .catch(() => { if (active) setError('Unable to load course drafts. Please try again.'); });
    return () => { active = false; };
  }, []);
  return <main className="course-editor">
    <h1>Your course drafts</h1>
    <p><Link to="/editor/course/new">Create course</Link> · <Link to="/courses">Choose a published course to edit</Link></p>
    {error && <p role="alert">{error}</p>}
    {!drafts && !error && <p><output>Loading course drafts…</output></p>}
    {drafts?.length === 0 && <p>No course drafts yet.</p>}
    <ul>{drafts?.map(draft => <li key={draft.id}><Link to={`/editor/course-drafts/${draft.id}`}>{draft.title || 'Untitled course'}</Link></li>)}</ul>
  </main>;
}
